import { $, $$} from '@utils/dom';
import { on, off } from "@utils/listener";
import Wishlist from "@core/wishlist";

class ProductWishlist {
  constructor(el, emitter) {
    this.el = el;
    this.emitter = emitter;

    this._initialized = false;

    this._toggleItem = this._toggleItem.bind(this);
    this._triggerToggle = this._triggerToggle.bind(this);
    this._triggerAlert = this._triggerAlert.bind(this);
    this._closeAlert = this._closeAlert.bind(this);
    this._verifySelection = this._verifySelection.bind(this);
    this._update = this._update.bind(this);

    this.init();
  }

  init() {
    if(this._initialized) return;
    this._initialized = true;

    this.customerId = this.el.getAttribute('data-customer-id');
    this.productHandle = this.el.getAttribute('data-product-handle');
    this.variantId = parseInt(this.el.getAttribute('data-variant-id'));

    this._selected = this.el.getAttribute('aria-selected') == 'true' ? true : false;

    this.btns = [ ...$$(".product-wishlist__btn", this.el)];
    this.alert = $(".product-wishlist__alert");

    if (this.alert) {
      this.alertClose = $(".product-wishlist__alertClose");
    }

    this.observer = new MutationObserver(this._update);

    this._bindEvents();
  }
  destroy() {
    this._unbindEvents();

    this.observer = null;

    this.el = null;
    this.emitter = null;

    this.customerId  = null;
    this.productHandle  = null;
    this.variantId  = null;
    this.btns = null;

    this._initialized = null;

    this._toggleItem = null;
    this._triggerToggle = null;
    this._triggerAlert = null;
    this._closeAlert = null;
    this._verifySelection = null;
    this._update = null;
  }

  start() {}
  stop() {}

  _bindEvents() {

    this.observer.observe(this.el, { attributes: true });
    if (this.btns) on(this.btns, 'click', this._triggerToggle);
    if (this.alertClose) on(this.alertClose, 'click', this._closeAlert);

    this.emitter.on('SiteWishlist.updated', this._verifySelection);
  }
  _unbindEvents() {
    this.observer.disconnect();
    if (this.btns) off(this.btns, 'click', this._triggerToggle);
    if (this.alertClose) on(this.alertClose, 'click', this._closeAlert);

    this.emitter.off('SiteWishlist.updated', this._verifySelection);
  }

  _triggerToggle(){
    if (!this.customerId) {
      this._triggerAlert();
    } else {
      this._toggleItem();
    }
  }

  _toggleItem(){
    if (this._selected) {
      this._removeItem();
    } else {
      this._addItem();
    }
  }

  _addItem(){
    this.el.classList.add('--updating');
    
    Wishlist.save(this.customerId, this.productHandle, this.variantId).then(state => {
      this.emitter.emit('SiteWishlist.update', state);
      this.el.classList.remove('--updating');
    });
  }

  _removeItem(){
    this.el.classList.add('--updating');

    Wishlist.delete(this.customerId, this.productHandle, this.variantId).then(state => {
      this.emitter.emit('SiteWishlist.update', state);
      this.el.classList.remove('--updating');
    });
  }

  _triggerAlert(){
    if (!this.alert) return;

    this.alert.setAttribute('aria-hidden', false);
    this.emitter.emit('SiteScroll.update');
  }

  _verifySelection() {
    if (!window.WishlistObj) return;
    
    let included = false;

    if(window.WishlistObj.find(el => el.variantID == this.variantId )) {
      included = true;
    }

    this._selected = included;
    this.el.setAttribute('aria-selected', this._selected);
  }

  _update(mutationList){
    if(!mutationList.find(el => el.attributeName == 'data-variant-id')) return;

    this.variantId = parseInt(this.el.getAttribute('data-variant-id'));
    this._verifySelection();
  }

  _closeAlert(){
    this.alert.setAttribute('aria-hidden', true);
    this.emitter.emit('SiteScroll.update');
  }

}


export default ProductWishlist;
